import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home.vue'
import Index from '../views'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },

  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about'),
  },
  {
    path: '/honor',
    name: 'honor',
    component: () => import('@/views/about/honor'),
  },
  {
    path: '/partner',
    name: 'partner',
    component: () => import('@/views/about/partner'),
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/about/video'),
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('@/views/case')
  },
  {
    path: '/casedetail',
    name: 'casedetail',
    component: () => import('@/views/case/detail')
  },
  {
    path: '/crafts',
    name: 'crafts',
    component: () => import('@/views/crafts')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/product/search')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/contact/message')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news')
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    component: () => import('@/views/news/detail')
  },
  // --------------英文
  {
    path: '/en',
    name: 'en',
    component: () => import('@/views/en'),
  },

  {
    path: '/en/home',
    redirect: '/en'
  },
  {
    path: '/en/about',
    name: 'enabout',
    component: () => import('@/views/en/about'),
  },
  {
    path: '/en/honor',
    name: 'enhonor',
    component: () => import('@/views/en/about/honor'),
  },
  {
    path: '/en/partner',
    name: 'enpartner',
    component: () => import('@/views/en/about/partner'),
  },
  {
    path: '/en/video',
    name: 'envideo',
    component: () => import('@/views/en/about/video'),
  },
  {
    path: '/en/case',
    name: 'encase',
    component: () => import('@/views/en/case')
  },
  {
    path: '/en/crafts',
    name: 'encrafts',
    component: () => import('@/views/en/crafts')
  },
  {
    path: '/en/product',
    name: 'enproduct',
    component: () => import('@/views/en/product')
  },
  {
    path: '/en/casedetail',
    name: 'encasedetail',
    component: () => import('@/views/en/case/detail')
  },
  {
    path: '/en/contact',
    name: 'encontact',
    component: () => import('@/views/en/contact')
  },
  {
    path: '/en/message',
    name: 'enmessage',
    component: () => import('@/views/en/contact/message')
  },
  {
    path: '/en/news',
    name: 'ennews',
    component: () => import('@/views/en/news')
  },
  {
    path: '/en/newsdetail',
    name: 'ennewsdetail',
    component: () => import('@/views/en/news/detail')
  },
  {
    path: '/en/search',
    name: 'ensearch',
    component: () => import('@/views/en/product/search')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  }
})

router.afterEach((to, from) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
